import $ from 'jquery';

export const init = () => {

	var autosubmitTimeout = null;
	var autosubmitNow = function(sender) {
		$(sender).closest('form').submit();
	};
	$(document)
		.on('click', '.js-auto-submit-checkbox', function(e) {
			if (autosubmitTimeout) {
				clearTimeout(autosubmitTimeout);
				autosubmitTimeout = null;
			}
			autosubmitTimeout = setTimeout(function() {
				autosubmitNow(e.target);
			}, 800);
		});

};

